<main>
  <loading-overlay [isLoading]="isLoading() > 0" />

  <div class="content history">
    <app-signing-session-bar />

    <nav class="history__breadcrumb">
      <i class="pi pi-home"></i>
      <i class="pi pi-angle-right history__breadcrumb-sep"></i>
      <span>{{ 'Signing_Menu_Signature' | translateWF: 'Signature' }}</span>
      <i class="pi pi-angle-right history__breadcrumb-sep"></i>
      <span class="history__breadcrumb-current">{{ 'Signing_History_Title' | translateWF: 'Session History' }}</span>
    </nav>

    <div>
      <h1 class="history__title">{{ 'Signing_History_Title' | translateWF: 'Session History' }}</h1>
      <p class="history__subtitle">
        {{ 'Signing_History_Subtitle' | translateWF: "A record of every signing session you've opened, and what happened in each." }}
      </p>
    </div>

    <div class="history__list">
      @for (card of cards(); track card.session.id) {
        <div class="history__card">
          <div class="history__card-header">
            <div class="history__card-heading">
              <span class="history__id" [pTooltip]="card.session.id">{{ card.shortId }}</span>
              <span class="history__card-meta"> {{ 'Signing_History_Opened' | translateWF: 'Opened' }} {{ card.session.openedAt | date: 'yyyy/MM/dd hh:mm a' }} </span>
              <span class="history__card-meta">{{ 'Signing_History_Duration' | translateWF: 'Duration' }} {{ card.duration }}</span>
            </div>
            <p-tag [value]="card.statusLabel" [severity]="card.severity" />
          </div>

          <div class="history__facts">
            <div class="history__fact">
              <span class="history__fact-label">{{ 'Signing_History_Verified' | translateWF: 'Verified' }}</span>
              <span class="history__fact-value">
                {{ card.session.verifiedAt ? (card.session.verifiedAt | date: 'yyyy/MM/dd hh:mm a') : '—' }}
              </span>
            </div>
            <div class="history__fact">
              <span class="history__fact-label">{{ 'Signing_History_Ended' | translateWF: 'Ended' }}</span>
              <span class="history__fact-value">
                {{ card.session.endedAt ? (card.session.endedAt | date: 'yyyy/MM/dd hh:mm a') : '—' }}
              </span>
            </div>
            <div class="history__fact">
              <span class="history__fact-label">{{ 'Signing_History_Reason' | translateWF: 'End reason' }}</span>
              <span class="history__fact-value">{{ card.reasonLabel }}</span>
            </div>
            <div class="history__fact">
              <span class="history__fact-label">{{ 'Signing_History_Actions' | translateWF: 'Signing actions' }}</span>
              <span class="history__fact-value">{{ card.session.activityCount }}</span>
            </div>
            <div class="history__fact">
              <span class="history__fact-label">{{ 'Signing_History_Method' | translateWF: 'Verification method' }}</span>
              <span class="history__fact-value">{{ card.verificationMethod }}</span>
            </div>
          </div>

          <div class="history__trail">
            <a href="#" class="history__toggle" (click)="toggle($event, card.session.id)">
              <i class="pi" [class.pi-chevron-down]="expandedId() !== card.session.id" [class.pi-chevron-up]="expandedId() === card.session.id"></i>
              {{
                expandedId() === card.session.id ? ('Signing_History_HideActivity' | translateWF: 'Hide activity') : ('Signing_History_ShowActivity' | translateWF: 'Show activity')
              }}
            </a>

            @if (expandedId() === card.session.id) {
              @if (loadingEvents()) {
                <div class="history__trail-loading"><i class="pi pi-spin pi-spinner"></i></div>
              } @else {
                <table class="history__events">
                  <thead>
                    <tr>
                      <th>{{ 'Signing_History_Col_Event' | translateWF: 'Event' }}</th>
                      <th>{{ 'Signing_History_Col_When' | translateWF: 'When' }}</th>
                      <th>{{ 'Signing_History_Col_Detail' | translateWF: 'Detail' }}</th>
                      <th>{{ 'Signing_History_Col_Ip' | translateWF: 'IP address' }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (event of events(); track event.id) {
                      <tr>
                        <td class="history__event-name">
                          <i [class]="eventIcon(event.eventType)"></i>
                          {{ eventLabel(event.eventType) }}
                        </td>
                        <td>{{ event.occurredAt | date: 'yyyy/MM/dd hh:mm:ss a' }}</td>
                        <td>{{ eventDetail(event) }}</td>
                        <td class="history__mono">{{ event.ipAddress || '—' }}</td>
                      </tr>
                    } @empty {
                      <tr>
                        <td colspan="4" class="history__events-empty">{{ 'Signing_History_NoEvents' | translateWF: 'No activity recorded.' }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            }
          </div>
        </div>
      } @empty {
        @if (isLoading() === 0) {
          <div class="history__empty">
            <i class="pi pi-history history__empty-icon"></i>
            <span class="history__empty-title">{{ 'Signing_History_Empty' | translateWF: "You haven't opened any signing sessions yet." }}</span>
          </div>
        }
      }
    </div>
  </div>
</main>
